import {
  Divider,
  Link,
  MenuItem,
  Button as MuiButton,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import styled from "styled-components";

export const StyledMenuItem = styled(MenuItem)`
  display: block;
  opacity: 1 !important;
  cursor: ${({ disabled }) => disabled && "default"};
  pointer-events: ${({ disabled }) => disabled && "none"};
  p {
    opacity: ${({ disabled }) => disabled && "0.5"};
  }
  &:hover {
    background: ${({ disabled }) => disabled && "none"};
  }
`;

export const StyledDivider = styled(Divider)`
  margin: 8px 0 8px 0;
`;

export const SyncDialogCloseButton = styled(CloseIcon)`
  font-size: 16px;
  position: absolute;
  right: -10px;
  top: 0;
  cursor: pointer;
  :hover {
    color: red;
  }
`;

export const SyncDialogContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: flex-start;
  padding: 10px 20px 20px 20px;
  justify-content: center;
`;

export const SyncDialogTitleContainer = styled.div`
  width: 100%;
  position: relative;
`;

export const EnableButton = styled(MuiButton)`
  pointer-events: visible;
  padding: 2px 8px;
  font-size: 0.7rem;
  min-width: 60px;
  margin-left: 10px;
`;

export const DisabledLabel = styled(Typography)`
  pointer-events: none;
  cursor: pointer;
`;

export const StorageAccountsLink = styled(Link)`
  margin-left: 10px;
  font-size: 12px;
  cursor: pointer;
  pointer-events: visible;
`;
